/** Styl dialogu k tématu Erma */
export const DialogStyles = {
  background: 'var(--erma-primary-0)',
  borderRadius: 'var(--erma-border-radius-sm)',
  contentPadding: '1rem',
  header: {
    padding: '1rem',
  },
  footer: {
    padding: '1rem',
    gap: '0.5rem'
  },
  title: {
    fontWeight: '700',
    fontSize: '1rem'
  },
  extend: {
    headerExtend: {
      background: 'var(--erma-secondary-40)',
      borderRadius: 'var(--erma-border-radius-sm)',
      borderBottom: '1px solid var(--erma-secondary-220)'
    }
  },
  css: ({ dt }) => `
        .p-dialog-header {
           background: ${dt('dialog.headerExtend.background')};
           border-top-right-radius: ${dt('dialog.headerExtend.borderRadius')};
           border-top-left-radius: ${dt('dialog.headerExtend.borderRadius')};
           border-bottom: ${dt('dialog.headerExtend.borderBottom')};
        }`
};
